export const PhoneNum = '+44 203 6338015';
export const PhoneNumNoSpace = 'tel:+442036338015';
export const MobPhoneNum = '+44 7960 355406';
export const MobPhoneNumNoSpace = 'tel:+447960355406';
